/**
 * Права модуля самоопределения — синхронизировать с `CreativeSelfDefinitionPermissions` на бэкенде.
 * При 403 проверьте фактическое имя политики в ответе `/api/abp/application-configuration`.
 */
export const CREATIVE_SELF_DEFINITION_MODERATE = "LeninkaArt.CreativeSelfDefinition.Moderate"

/** Модерация каталога типовых ролей (create / update description / soft-delete). */
export const CREATIVE_SELF_DEFINITION_MANAGE_CATALOG =
  "LeninkaArt.CreativeSelfDefinition.ManageCatalog"
